import { describeS3UploadFailure, PresignedPostUploadTarget } from '@gearbelt/global';

async function readBody(response: Response): Promise<string> {
  try {
    return await response.text();
  } catch {
    return '';
  }
}

export async function postToPresignedTarget(target: PresignedPostUploadTarget, file: File | Blob, label = 'Upload'): Promise<void> {
  const body = new FormData();
  Object.entries(target.fields).forEach(([key, value]) => body.append(key, value));
  body.append('file', file);

  const response = await fetch(target.url, { method: 'POST', body });
  if (response.ok) return;

  throw new Error(describeS3UploadFailure({ responseBody: await readBody(response), statusText: response.statusText, label }));
}
